const ChevronDown = ({ width = 28, height = 28, color = 'currentColor', ...props }) => {
  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      color={color}
      {...props}
    >
      <path
        d="M5.5 7.5L10.5 12.5L15.5 7.5"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChevronDown
